import * as React from 'react';

function SvgReferralInfoCircle(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zm0 11.21a5.087 5.087 0 11.002-10.173A5.087 5.087 0 017 12.086z"
        fill="#000"
        fillOpacity={0.45}
      />
      <path
        d="M6.344 4.594a.656.656 0 101.312 0 .656.656 0 00-1.312 0zm.984 1.531h-.656a.11.11 0 00-.11.11v3.718c0 .06.05.11.11.11h.656c.06 0 .11-.05.11-.11V6.234a.11.11 0 00-.11-.109z"
        fill="#000"
        fillOpacity={0.45}
      />
    </svg>
  );
}

export default SvgReferralInfoCircle;
